module.exports = __webpack_public_path__ + "static/media/suzlon.1152ec45.png";